var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_4734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 10.8307C4.16797 10.3887 4.34356 9.96478 4.65612 9.65222C4.96868 9.33966 5.39261 9.16406 5.83464 9.16406H14.168C14.61 9.16406 15.0339 9.33966 15.3465 9.65222C15.659 9.96478 15.8346 10.3887 15.8346 10.8307V15.8307C15.8346 16.2728 15.659 16.6967 15.3465 17.0092C15.0339 17.3218 14.61 17.4974 14.168 17.4974H5.83464C5.39261 17.4974 4.96868 17.3218 4.65612 17.0092C4.34356 16.6967 4.16797 16.2728 4.16797 15.8307V10.8307Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 13.3333C9.16797 13.5543 9.25577 13.7663 9.41205 13.9226C9.56833 14.0789 9.78029 14.1667 10.0013 14.1667C10.2223 14.1667 10.4343 14.0789 10.5906 13.9226C10.7468 13.7663 10.8346 13.5543 10.8346 13.3333C10.8346 13.1123 10.7468 12.9004 10.5906 12.7441C10.4343 12.5878 10.2223 12.5 10.0013 12.5C9.78029 12.5 9.56833 12.5878 9.41205 12.7441C9.25577 12.9004 9.16797 13.1123 9.16797 13.3333Z",
    stroke: "#555555",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 9.16667V5.83333C6.66797 4.94928 7.01916 4.10143 7.64428 3.47631C8.2694 2.85119 9.11725 2.5 10.0013 2.5C10.8854 2.5 11.7332 2.85119 12.3583 3.47631C12.9834 4.10143 13.3346 4.94928 13.3346 5.83333V9.16667",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_4734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.1894004a8cdbb617046e71403bd5061b.svg";
export { ForwardRef as ReactComponent };